module.exports = __webpack_public_path__ + "media/notice.b08fa562.mp3";